import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";
import { Helmet } from "react-helmet-async";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <>
    <Helmet>
      <title>Contact | Placement & Business Services Ltd</title>
      <meta
        name="description"
        content="Get in touch with us for inquiries, support, or feedback."
      />

      <link rel="canonical" href="https://www.pbslja.com/contact" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact",
          "url": "https://www.pbslja.com/contact",
          "description": "Get in touch with us for inquiries, support, or feedback.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.pbslja.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Contact",
                "item": "https://www.pbslja.com/contact"
              }
            ]
          }
        })}
      </script>
    </Helmet>
    <AnimationRevealPage>
      <Header />
      <ContactUsForm />
      {/* <ContactDetails
        cards={[
          {
            title: "Kingston",
            description: (
              <>
                <Address>
                  <AddressLine>Shop 14 MidSpring Plaza</AddressLine>
                  <AddressLine>134 Constant Spring Road, Kingston 8</AddressLine>
                </Address>
                <Email>placementservicebiz@gmail.com</Email>
                <Phone>+1 (876) 926-8359</Phone>
              </>
            )
          }
        ]}
      /> */}

      {/* Google Map Embed */}
      <div tw="w-full h-96 mt-8 mb-8">
        <iframe
          title="Kingston Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3793.7034706419618!2d-76.79552129999999!3d18.038960100000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8edb3fb35217de35%3A0xca17734bdda6ea17!2sPlacement%20%26%20Business%20Services%20Ltd.!5e0!3m2!1sen!2sjm!4v1755116277233!5m2!1sen!2sjm"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <Footer />
    </AnimationRevealPage>
    </>
  );
};
